import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IUpdate = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={props.width??"15"} height={props.height??"14"} viewBox="0 0 18 24" fill="none">
          <path d="M9 0L5 4L9 8V5C12.859 5 16 8.14 16 12C16 12.88 15.8293 13.7201 15.5312 14.4961L17.0469 16.0098C17.6519 14.8008 18 13.442 18 12C18 7.038 13.963 3 9 3V0ZM0.953125 7.99023C0.348125 9.19923 0 10.558 0 12C0 16.962 4.037 21 9 21V24L13 20L9 16V19C5.141 19 2 15.86 2 12C2 11.12 2.17075 10.2799 2.46875 9.50391L0.953125 7.99023Z" fill={props.color??"#37474F"}/>
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IUpdate;
